import {
  fetchBuyPackage,
  IBuyPackageRequest,
} from '../../../repositories/billing-service-packages-balancer/v1/buy-package';
import { IHttpApi } from '@cian/http-api/shared';
import { ILogger } from '@cian/logger';
import { THeaders } from '../../../types/request';

interface IBuyPackageParams {
  httpApi: IHttpApi;
  logger: ILogger;
  parameters: IBuyPackageRequest;
}

const DEFAULT_RESPONSE = {
  code: 'Error',
};

export const buyPackage = async (params: IBuyPackageParams) => {
  const { httpApi, logger, parameters } = params;

  const config = {
    requestConfig: {
      headers: [['Content-Type', 'application/json']] as THeaders,
    },
  };

  try {
    const { response } = await fetchBuyPackage({ httpApi, parameters, config });

    return response || DEFAULT_RESPONSE;
  } catch (error) {
    logger.error(error, {
      description: 'Add form billing-service-packages-balancer/v1/buy-package rejection error',
      degradation: 'Пользователь не смог купить пакет',
    });

    return DEFAULT_RESPONSE;
  }
};
